import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import PageLoading from "../../../../components/Loading/PageLoading";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import { useLoading } from "../../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { downloadExcelFile } from "../../../function/downloadExcel";
import {
  allCustomers,
  allUsers,
  allProducts,
  FilterProductFeedback,
  ExportProductFeedback,
  getAllDeliveries,
  deliveryReport,
  exportdeliveryreport,
  todayCustomersDropdown,
} from "../ReportData";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import {
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
} from "recharts";
import OptionConvert from "../../../components/OptionConvert";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../ReportStateMange";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import URL from "../../../../pages/Utils/url";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReusableFilter from "../../../components/ReusableFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import ReportDefaultUi from "../reportDefaultui";
import AppliedFilter from "../AppliedFilter/AppliedFilter";

function DeliveryReport() {
  const { setCirleLoading } = useLoading();
  const [deliveryReportData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState
  );
  const [isTabel, setIsTabel] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [datas, setData] = useState([]);
  const [value, setValue] = useState(0);
  const [agentOptions, setAgentOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [customerOptions, setCustomerOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const deliveryOptions = [
    { label: "All", value: "All" },
    { label: "Pending", value: "Pending" },
    { label: "Completed", value: "Completed" },
  ];

  const [dialogOpen, setDialogOpen] = useState(false);

  // Pagination state for graph view
  const [currentPage, setCurrentPage] = useState(0);
  const recordsPerPage = 5;

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([fetchCustomer(), fetchAgentName()]);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchAllData();
    // fetchDeliveryReport()
    setIsTabel(false);
  }, []);

  const processedData = datas.map((delivery) => ({
    customerName: delivery.customerName,
    totalQuantity: delivery.deliveryProducts.reduce(
      (total, product) => total + product.quantity,
      0
    ),
  }));

  // Calculate pagination values
  const totalPages = Math.ceil(datas?.length / recordsPerPage);
  const currentData = processedData?.slice(
    currentPage * recordsPerPage,
    (currentPage + 1) * recordsPerPage
  );

  // Pagination handlers
  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Reset pagination when data changes
  const resetPagination = () => {
    setCurrentPage(0);
  };

  //reset filter data
  const resetFilters = () => {
    dispatch({ name: "reset" });
    setData([]);
    setIsTabel(false);
    setIsLoading(false);
    setCurrentPage(1);
  };

  //table row and colomn
  const deliveryReportListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Agent",
        field: "agent",
        name: "agent",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Customer Name",
        field: "customerName",
        name: "customerName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Contact Person",
        field: "contactPerson",
        name: "contactPerson",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product",
        field: "productName",
        name: "productName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Status",
        field: "deliveryStatus",
        name: "deliveryStatus",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Check In Time",
        field: "checkInTime",
        name: "checkInTime",
        flex: 1,
        minWidth: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Check-in Latitude",
        field: "checkinLocationLat",
        name: "checkinLocationLat",
        flex: 1,
        minWidth: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Check-in Longitude",
        field: "checkinLocationLng",
        name: "checkinLocationLng",
        flex: 1,
        minWidth: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Check Out Time",
        field: "checkOutTime",
        name: "checkOutTime",
        flex: 1,
        minWidth: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Check-out Latitude",
        field: "checkoutLocationLat",
        name: "checkoutLocationLat",
        flex: 1,
        minWidth: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Check-out Longitude",
        field: "checkoutLocationLng",
        name: "checkoutLocationLng",
        flex: 1,
        minWidth: 150,
        disableColumnMenu: true,
        editable: false,
      },
      //   {
      //     headerName: "Action",
      //     field: "Action",
      //     name: "Action",
      //     flex: 1,
      //     disableColumnMenu: true,
      //     editable: false,
      //   },
    ],
    rows: datas.map((value, i) => {
      const checkins = Array.isArray(value?.checkins) ? value.checkins : [];
      const checkouts = checkins.flatMap((checkin) =>
        Array.isArray(checkin?.checkouts) ? checkin.checkouts : []
      );
      const formatValues = (records, field) =>
        records
          .map((record) => record?.[field])
          .filter(
            (fieldValue) =>
              fieldValue !== null &&
              fieldValue !== undefined &&
              fieldValue !== ""
          )
          .join(", ") || "—";

      return {
        id: value?.id,
        sno: i + 1,
        agent: value?.repName,
        customerName: value?.customerName,
        marketName: value?.marketName,
        contactPerson: value?.contactPerson,
        deliveryStatus: value?.deliveryStatus,
        checkInTime: formatValues(checkins, "checkInTime"),
        checkinLocationLat: formatValues(checkins, "checkinLocationLat"),
        checkinLocationLng: formatValues(checkins, "checkinLocationLng"),
        checkOutTime: formatValues(checkouts, "checkOutTime"),
        checkoutLocationLat: formatValues(checkouts, "checkoutLocationLat"),
        checkoutLocationLng: formatValues(checkouts, "checkoutLocationLng"),
        productName: value?.deliveryProducts
          ?.map((product) => product.productName)
          .join(", "),
        //   Action: (
        //     <div
        //       style={{
        //         display: "flex",
        //         justifyContent: "space-evenly",
        //         marginTop: "10px",
        //         alignItems: "center",
        //       }}
        //     >
        //       <VisibilityIcon
        //         style={{ color: "GrayText", fontSize: "20px", cursor: "pointer" }}
        //         onClick={() =>
        //           navigate(`/outstanding-balance/view`, {
        //             state: { type: "view", data: value },
        //           })
        //         }
        //       />
        //     </div>
        //   ),
      };
    }),
  };

  //download file
  const handleDownload = (
    startDate,
    endDate,
    customersName,
    agentsName,
    deliveryStatuses
  ) => {
    const customers =
      customersName?.length > 0
        ? customersName?.map((item) => item.label) || []
        : [];
    const agents =
      agentsName?.length > 0 ? agentsName?.map((item) => item.label) || [] : [];

    const delivery =
      deliveryStatuses?.length > 0
        ? deliveryStatuses.map((item) => item.label)
        : [];
    setCirleLoading(true);
    request(BASEURL, exportdeliveryreport, {
      startdate: startDate,
      enddate: endDate,
      customerNames: customers,
      agents: agents,
      deliveryStatuses: delivery,
    })
      .then(async (res) => {
        const status = res?.exportDeliveryReport?.success;

        const pdfurl = `${URL}${res?.exportDeliveryReport?.fileUrl?.slice(1)}`;

        if (status) {
          const status = await downloadExcelFile(
            pdfurl,
            "delivery_report.xlsx"
          );
          setCirleLoading(false);
        }
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  //get customer option
  const fetchCustomer = () => {
    request(BASEURL, todayCustomersDropdown)
      .then((res) => {
        const customer = OptionConvert(
          res?.todayCustomersDropdown?.data,
          "customerName",
          "id"
        );
        setCustomerOptions((prevOptions) => [...prevOptions, ...customer]);
      })
      .finally(() => {});
  };

  //get agent name option
  const fetchAgentName = () => {
    request(BASEURL, allUsers)
      .then((res) => {
        const productName = OptionConvert(res?.allUsers, "employeeName", "id");
        setAgentOptions((prevOptions) => [...prevOptions, ...productName]);
      })
      .finally(() => {});
  };

  //filter api call
  const fetchDeliveryReport = (
    startDate,
    endDate,
    agents,
    customers,
    deliveryStatuses
  ) => {
    setIsLoading(true);
    setIsTabel(true);

    const input = {
      startDate: startDate || null,
      endDate: endDate || null,
      customerNames: customers || [],
      agents: agents || [],
      deliveryStatuses: deliveryStatuses || [],
    };

    request(BASEURL, deliveryReport, { input: input })
      .then((res) => {
        const newdata = res?.deliveryReport?.data;
        setData(newdata);
        resetPagination();
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
        setIsTabel(true);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //filter submit
  const submitFilter = (data) => {
    const agentName =
      deliveryReportData?.agentName?.length > 0
        ? deliveryReportData?.agentName.map((item) => item.label)
        : [];
    const customerName =
      deliveryReportData?.customerName?.length > 0
        ? deliveryReportData?.customerName.map((item) => item.label)
        : [];

    const productName =
      deliveryReportData?.productName?.length > 0
        ? deliveryReportData?.productName.map((item) => item.label)
        : [];

    const deliveryStatuses =
      deliveryReportData?.deliveryStatuses?.length > 0
        ? deliveryReportData?.deliveryStatuses.map((item) => item.label)
        : [];

    fetchDeliveryReport(
      deliveryReportData.fromDate,
      deliveryReportData.toDate,
      agentName,
      customerName,
      deliveryStatuses
    );
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Delivery Report List
                </MaterialTypography>
              </Stack>
              <Box sx={{ mx: "5%" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {datas.length > 0 && (
                    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        TabIndicatorProps={{
                          style: {
                            backgroundColor: "#2a9941",
                            color: "white",
                          },
                        }}
                        sx={{ px: 2 }}
                        centered
                      >
                        <Tab sx={{ px: 2 }} label="Table list view" />
                        <Tab sx={{ px: 2 }} label="Graph view" />
                      </Tabs>
                    </Box>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      bgcolor: "background.paper",
                    }}
                  >
                    <IconButton
                      onClick={() => setDialogOpen(true)}
                      aria-label="Filters"
                      color="primary"
                    >
                      <FilterListIcon fontSize="medium" />
                    </IconButton>
                    <IconButton
                      onClick={resetFilters}
                      aria-label="Reset Filters"
                      color="primary"
                    >
                      <RefreshIcon fontSize="medium" />
                    </IconButton>
                  </Box>
                </Stack>
              </Box>
              {deliveryReportData?.fromDate && deliveryReportData?.toDate && (
                <button
                  className="container-btn-file"
                  onClick={() => {
                    handleDownload(
                      deliveryReportData?.fromDate,
                      deliveryReportData?.toDate,
                      deliveryReportData?.customerName,
                      deliveryReportData?.agentNametoDate,
                      deliveryReportData?.deliveryStatuses,
                    );
                  }}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
            </Stack>
          }
        />
        {/* taps */}
        <AppliedFilter
          onSave={(data) =>
            submitFilter({
              ...data,
              deliveryReportData,
            })
          }
          data={deliveryReportData}
          dispatch={dispatch}
          chipDisplay={["agentName", "customerName", "deliveryStatuses"]}
        />

        <ReusableFilter
          data={deliveryReportData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              deliveryReportData,
            })
          }
          title="Delivery Report Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agent Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={agentOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={deliveryReportData?.agentName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "agentName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Customer Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={customerOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={deliveryReportData?.customerName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "customerName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Customer(s)" />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Delivery Status
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={deliveryOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={deliveryReportData?.deliveryStatuses || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "deliveryStatuses" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Delivery Status(s)"
                />
              )}
            />
          </Grid>
        </ReusableFilter>

        {!isLoading && isTabel && (
          <>
            {value === 0 ? (
              //Table list view
              <Box>
                {!isLoading && (
                  <MaterialDataGrid
                    rows={deliveryReportListTable?.rows}
                    columns={deliveryReportListTable?.columns}
                    isSelectable={false}
                    localeText={{
                      noRowsLabel: (
                        <Stack
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                          spacing={1}
                        >
                          <MaterialTypography
                            variant="body2"
                            fontWeight="medium"
                            color="text"
                          >
                            No results match your filters
                          </MaterialTypography>

                          <MaterialTypography variant="caption" color="text">
                            Try adjusting or clearing the filters to see
                            Delivery Report data.
                          </MaterialTypography>
                        </Stack>
                      ),
                    }}
                  />
                )}
              </Box>
            ) : (
              //graph list view with pagination
              <Box>
                <ResponsiveContainer width="100%" height={450}>
                  <BarChart
                    data={currentData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    barSize={30}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="customerName"
                      tick={{ fontSize: 12 }} // ⬅ smaller text
                      tickMargin={8}
                    />
                    <YAxis
                      tick={{ fontSize: 12 }} // ⬅ smaller text
                      tickMargin={8}
                    />
                    <Tooltip
                      contentStyle={{
                        fontSize: "12px",
                        borderRadius: "8px",
                        background: "rgba(255, 255, 255, 0.8)",
                        border: "1px solid #ccc",
                        padding: "2px",
                      }}
                      wrapperStyle={{ outline: "none" }}
                    />
                    <Legend wrapperStyle={{ fontSize: "12px" }} />
                    <Bar
                      dataKey="totalQuantity"
                      fill="#8884d8"
                      name="Total Quantity"
                    />
                  </BarChart>
                </ResponsiveContainer>

                {/* Pagination controls */}
                <Box display="flex" justifyContent="center" mt={2} mb={2}>
                  <IconButton
                    onClick={handlePrevious}
                    disabled={currentPage === 0}
                    aria-label="previous page"
                  >
                    <ArrowBackIosIcon />
                  </IconButton>
                  <Typography variant="body1" mx={2}>
                    Page {currentPage + 1} of {totalPages}
                  </Typography>
                  <IconButton
                    onClick={handleNext}
                    disabled={currentPage >= totalPages - 1}
                    aria-label="next page"
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>
                </Box>
              </Box>
            )}
          </>
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
}

export default DeliveryReport;
